"use strict";
var SERVICE_PROVIDER = require('./serviceProvider');
var CURRENCY = require('./currency');
var SHAREHOLDER_TYPES = require('./shareholderTypes');
var REGISTER = require('./register');
module.exports = {
    SERVICE_PROVIDER: SERVICE_PROVIDER,
    CURRENCY: CURRENCY,
    SHAREHOLDER_TYPES: SHAREHOLDER_TYPES,
    REGISTER: REGISTER
};
